import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { roles } from "utils/constant";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";

const EmployeeDeliveryReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const tableRef = useRef(null);

  const [tableData, setTableData] = useState<any>([]);
  const [tableDetails, setTableDetails] = useState<any>([]);

  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    fromDate: moment().startOf("day"),
    toDate: moment().endOf("day"),
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [selectedAgent, setSelectedAgent] = useState({ id: undefined, name: "--- Select User ---" });
  const [allAgents, setAllAgents] = useState([]);

  useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      if (userD.state.user.roleName == roles.SUPER_ADMIN) {
        mutateListAgents({ subbranch: undefined });
      } else if (userD.state.user.roleName == roles.SUBBRANCH_ADMIN || userD.state.user.roleName == roles.CUSTOMER_SERVICE) {
        mutateListAgents({ subbranch: userD.state.user?.subbranch });
      } else {
        mutateListAgents({ subbranch: undefined });
      }
    }
  }, []);
  const { mutate: mutateListAgents }: any = useMutation(
    (qry: any) => ListCommanWay("/admin/user/list", { subbranch: qry?.subbranch, isActive: true }, { paginate: 100000 }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setAllAgents([{ id: undefined, name: "--- Select User ---" }, ...data.data.data]);
        }
      },
      onError: (data: any) => {},
    }
  );

  const handleSubmit = async () => {
    console.log("Ad");
    setIsDataAdded(!isDataAdded);
    setQuery({
      fromDate: startDate ? moment(startDate).startOf('day') : moment().startOf("day"),
      toDate: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
      userId: userDetails.roleName == "DELIVERY" ? userDetails.id : selectedAgent.id ? selectedAgent.id : undefined,
    });
  };

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_deli_report_list"],
    () =>
      ListCommanWay("/admin/emp_delivery/report", query, {
        include: [],
        paginate: 10000,
        doSum: true,
      }),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          let tdata = [];
          data.data.data.forEach(t => {
            if(selectedAgent.id == t["_awb_no._drs.addedBy"]){
              tdata.push(t);
            }
          })
          setTableData(tdata);
          setTableDetails([]);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );


  useEffect(() => {
    if (query.userId) {
      //
    }
    refetch();
  }, [query]);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});


  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Delivery Report.xlsx");
  };

  return (
    <>
      <h1 className="text-center mb-4 mt-3 text-lg font-semibold ">Employee Delivery Report</h1>
      <div className="flex items-end flex-col gap-4 px-4  border-[1px] p-4 m-4 rounded-md">
        <div className="flex gap-1 items-center flex-wrap border p-2 rounded-xl bg-gray-200 border-blue-600 w-full">
          {[1, 2, 3, 5, 8, 9].includes(userDetails.role_name) && (
            <div className={`inline-flex items-center gap-2 mr-6`}>
              <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">Select Employee</label>
              <Select
                className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-52 `}
                options={allAgents}
                onChange={(e: any) => {
                  setSelectedAgent(e);
                }}
                value={selectedAgent}
                getOptionValue={(e) => {
                  return e.id + "";
                }}
                getOptionLabel={(e) => {
                  return e.name;
                }}
              />
            </div>
          )}

          <AfDateRangePicker
          
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate} setEndDate={setEndDate} label="Start - End Date" />

          <button
            type="button"
            onClick={handleSubmit}
            className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Search
          </button>

          <button onClick={exportToExcel} className=" bg-blue-600 text-white px-4 py-1 rounded-md">
            Excel Export
          </button>
        </div>
      </div>
      <div>
        <table className="w-full table- mb-4 text-sm" id="myTable" ref={tableRef}>
          <thead>
            <tr>
              <th className="border border-slate-200">Sr.</th>
              <th className="border border-slate-200">AWB No</th>
              <th className="border border-slate-200">Reciever</th>
              <th className="border border-slate-200">Delivery Date</th>
              <th className="border border-slate-200">System Date</th>
              <th className="border border-slate-200">Shipper</th>
              <th className="border border-slate-200">Origin</th>
              <th className="border border-slate-200">Consignee</th>
              <th className="border border-slate-200">Destination</th>
              <th className="border border-slate-200">DRS No</th>
              <th className="border border-slate-200">Status</th>
              <th className="border border-slate-200">Updated From</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((r, i) => {
              return (
                <tr className={`${r["_awb_no.status"] === "0" ? "bg-green-300" : "bg-yellow-200"}`}>
                  <td className="border border-slate-200 px-4 text-center">{i + 1}</td>
                  <td className="border border-slate-200 px-4 text-center text-primary">
                    <a href={`/pod/tracking?awb=${r["_awb_no.awb_no"]}`} target="_blank">
                      {r["_awb_no.awb_no"]}
                    </a>
                  </td>
                  <td className="border border-slate-200 px-22 text-center">{r.receiver}</td>
                  <td className="border border-slate-200 px-2 text-center min-w-[100px] w-[100px]">
                    {r.message_code == "Shipment Delivered" ? moment(r.updatedAt).format("DD-MM-YYYY HH:mm") : ""}
                  </td>
                  <td className="border border-slate-200 px-2 text-center min-w-[100px] w-[100px]">
                    {moment(r.createdAt).format("DD-MM-YYYY HH:mm")}
                  </td>
                  <td className="border border-slate-200 px-2 text-center">{r["_awb_no._assign_to_booking.shipper_sh"]}</td>
                  <td className="border border-slate-200 px-2 text-center">{r["_awb_no._assign_to_booking.shipper_city"]}</td>
                  <td className="border border-slate-200 px-2 text-center">{r["_awb_no.consignee"]}</td>
                  <td className="border border-slate-200 px-2 text-center">{r["_awb_no.destination"]}</td>
                  <td className="border border-slate-200 px-2 text-center">{r["_awb_no._drs.code"]}</td>
                  <td className="border border-slate-200 px-2 text-center">
                    {r["_awb_no.status"] === "0" ? "Delivered" : r["_awb_no.status"]}
                  </td>
                  <td className="border border-slate-200 px-4 text-center">{r.isMobile == 1 ? "Mobile" : "Web"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default EmployeeDeliveryReport;
